import { graphql } from "msw";
import { locationsList } from "./locationsList";
import {
  GetLocationSuggestionsQuery,
  GetLocationSuggestionsQueryVariables,
} from "@cart-app/generated/graphql";

export const handler = graphql.query<
  GetLocationSuggestionsQuery,
  GetLocationSuggestionsQueryVariables
>("GetLocationSuggestions", (req, res, ctx) => {
  const getMatchedLocations = () => {
    const { suburb, postcode, searchTerm } = req.variables;

    if (!suburb && !postcode && !searchTerm) {
      return locationsList;
    }

    const list = locationsList.filter((location) => {
      if (searchTerm) {
        return (
          location.postcode.toLowerCase().includes(searchTerm.toLowerCase()) ||
          location.suburb.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      return (
        (postcode &&
          location.postcode.toLowerCase().includes(postcode.toLowerCase())) ||
        (suburb && location.suburb.toLowerCase().includes(suburb.toLowerCase()))
      );
    });

    return list;
  };

  return res(
    ctx.data({
      locationSuggestions: {
        postcodes: getMatchedLocations(),
      },
    })
  );
});
